import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiCommonModule, RegHubDateAdapter, REG_HUB_DATE_FORMATS } from 'reg-hub-common';
import { environment } from '../../environments/environment';
import { SharedModule } from 'projects/reg-hub-admin/src/app/shared/shared.module';
import { AccountingComponent } from './accounting/accounting.component';
import { AccountingRoutingModule } from './accounting-routing.module';
import { AccountingOptionsComponent } from './accounting-options/accounting-options.component';
import { ServicePricingComponent } from './service-pricing/service-pricing.component';
import { ServicePricingFilterComponent } from './service-pricing-filter/service-pricing-filter.component';
import { DisbursementPricingFilterComponent } from './disbursement-pricing-filter/disbursement-pricing-filter.component';
import { DisbursementPricingComponent } from './disbursement-pricing/disbursement-pricing.component';
import { InvoicesComponent } from './invoices/invoices.component';
import { InvoicesFilterComponent } from './invoices-filter/invoices-filter.component';
import { InvoiceInfoComponent } from './invoice-info/invoice-info.component';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { InvoiceFeesFilterComponent } from './invoice-fees-filter/invoice-fees-filter.component';
import { InvoiceFeesComponent } from './invoice-fees/invoice-fees.component';
import { SubscriptionFeesListFilterComponent } from './subscription-fees-list-filter/subscription-fees-list-filter/subscription-fees-list-filter.component';
import { SubscriptionFeesListComponent } from './subscription-fees-list/subscription-fees-list/subscription-fees-list.component';
import { TranslocoModule } from '@jsverse/transloco';

@NgModule({
    declarations: [
        AccountingComponent,
        AccountingOptionsComponent,
        ServicePricingFilterComponent,
        ServicePricingComponent,
        DisbursementPricingFilterComponent,
        DisbursementPricingComponent,
        InvoicesFilterComponent,
        InvoicesComponent,
        InvoiceInfoComponent,
        InvoiceFeesFilterComponent,
        InvoiceFeesComponent,
        SubscriptionFeesListFilterComponent,
        SubscriptionFeesListComponent
    ],
    imports: [
        TranslocoModule,
        CommonModule,
        SharedModule,
        UiCommonModule.forRoot({ rootUrl: environment.urlAddress, batchRootURL: environment.batchUrlAddress, consortiumRootURL: environment.consortiumUrlAddress }),
        AccountingRoutingModule
    ],
    providers: [
      { provide: DateAdapter, useClass: RegHubDateAdapter},
      { provide: MAT_DATE_FORMATS, useValue: REG_HUB_DATE_FORMATS},
    ]
})
export class AccountingModule { }